// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hrRequestApprovalEntity from './entities/hr-request-approval.json';
import hrRequestApprovalMenu from '../pages/hr-request-approval/menu.json';
import hrRequestApprovalFullForm from '../pages/hr-request-approval/forms/full.json';
import hrRequestApprovalContextForm from '../pages/hr-request-approval/forms/context.json';
import hrRequestApprovalMiniForm from '../pages/hr-request-approval/forms/mini.json';
import hrRequestApprovalLookupForm from '../pages/hr-request-approval/forms/lookup.json';
import hrRequestApprovalTableView from '../pages/hr-request-approval/views/table.json';
import hrRequestApprovalCardsView from '../pages/hr-request-approval/views/cards.json';
import hrRequestApprovalCalendarView from '../pages/hr-request-approval/views/calendar.json';
import hrRequestApprovalDashboardView from '../pages/hr-request-approval/views/dashboard.json';

/** Тип запису «Погодження заявки» зі сторінками пакета: меню, форми та подання з pages/hr-request-approval/. */
export const hrRequestApprovalDefinition: IRecordTypeDefinition = {
  ...hrRequestApprovalEntity,
  views: assembleViewSet({
      table: hrRequestApprovalTableView,
      cards: hrRequestApprovalCardsView,
      calendar: hrRequestApprovalCalendarView,
      dashboard: hrRequestApprovalDashboardView,
  }),
  form: hrRequestApprovalFullForm,
  forms: { full: hrRequestApprovalFullForm, context: hrRequestApprovalContextForm, mini: hrRequestApprovalMiniForm, lookup: hrRequestApprovalLookupForm },
  menu: hrRequestApprovalMenu,
} as IRecordTypeDefinition;
